import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Link } from "react-router-dom";

export default function Wishlist() {
  const { t } = useTranslation();
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/wishlist").then((r) => setProducts(r.data)).catch(() => {}); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="wishlist-page">
      <p className="overline">{t("wishlist.overline")}</p>
      <h1 className="font-serif text-5xl tracking-tight mt-2">{t("wishlist.title")}</h1>
      {products.length === 0 ? (
        <div className="mt-16 bg-boneAlt rounded-sm py-20 text-center">
          <p className="font-serif text-2xl">{t("wishlist.empty")}</p>
          <Link to="/shop" className="inline-block mt-6 bg-olive text-bone px-6 py-3 rounded-sm text-sm">{t("wishlist.browse")}</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mt-12" data-testid="wishlist-grid">
          {products.map((p) => <ProductCard key={p.product_id} product={p} testid="wishlist-product" />)}
        </div>
      )}
    </div>
  );
}
